"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticlesListModuleUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../dsl/front");
const ui_1 = require("../_abstract/ui");
const _contracts_1 = require("../_contracts");
const ui_2 = require("../_components/ui");
const ArticlesList_contracts_1 = require("./ArticlesList.contracts");
const ArticlesList_helpers_1 = require("./ArticlesList.helpers");
/**
 * Component capable of rendering the `ArticlesListModule's` contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let ArticlesListModuleUi = class ArticlesListModuleUi extends ui_1.AbstractModuleUi {
    constructor() {
        super(...arguments);
        this.AppTheme = _contracts_1.AppTheme;
        /**
         * Articles to render.
         */
        this.articles = [];
        this.headerLink = null;
        /**
         * "Read more" link.
         */
        this.readMoreLink = null;
    }
    /**
     * @inheritDoc
     */
    get articlesCount() {
        return ArticlesList_helpers_1.getArticlesCount(this.module.size, this.module.version);
    }
    /**
     * Appropriate Vue component that should be used to render the articles.
     */
    get component() {
        switch (this.module.version) {
            case ArticlesList_contracts_1.ArticlesListVersion.Thumbnails: {
                return ui_2.ThumbnailsList;
            }
            case ArticlesList_contracts_1.ArticlesListVersion.Text:
            default: {
                return ui_2.TextList;
            }
        }
    }
    /**
     * Determines whether there's a header text to render.
     */
    get hasHeaderText() {
        return typeof this.module.content.header !== 'undefined' &&
            typeof this.module.content.header.text === 'string' &&
            this.module.content.header.text.length > 0;
    }
    /**
     * Shortcut for `this.module.content.header`.
     */
    get header() {
        return this.module.content.header;
    }
    /**
     * Return listConfig.
     */
    get listConfig() {
        return {
            titleVersion: this.module.content.titleVersion,
            showArticleTags: this.module.content.showArticleTags
        };
    }
    /**
     * Determines whether there's a header to be rendered.
     */
    get shouldShowHeader() {
        const { header = {} } = this.module.content;
        if (!this.module.content.showHeader) {
            return false;
        }
        const keys = ['site', 'text'];
        for (const key of keys) {
            const value = header[key];
            if (typeof value === 'string' && value.length > 0) {
                return true;
            }
        }
        return false;
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        const { list, overrides, readMoreLink, allowDuplicates, startFromBeginning, headerLink } = this.module.content;
        // Determine if there's a list to resolve.
        if (list === null)
            return;
        try {
            const articles = await this.relatedService
                .resolve(list, {
                overrides,
                take: this.articlesCount,
                preventDuplicates: !allowDuplicates,
                continueOrder: !startFromBeginning
            });
            this.articles = (Array.isArray(articles) ? articles : [articles]);
            this.onReady();
        }
        catch (e) {
            this.onError(e);
        }
        if (typeof readMoreLink !== 'undefined') {
            try {
                const content = await this.relatedService.resolve(readMoreLink);
                this.readMoreLink = { target: { path: content.urlPath } };
            }
            catch (e) {
                if (this.debug) {
                    console.warn(e);
                }
            }
        }
        if (typeof headerLink !== 'undefined' && headerLink !== null) {
            try {
                const link = await this.relatedService.resolve(headerLink);
                this.headerLink = link.urlPath;
            }
            catch (e) {
                if (this.debug) {
                    console.warn(e);
                }
            }
        }
        this.articles.length > 0 ? this.onReady() : this.onError();
    }
    /**
     * Resolves length of articles' list displayed by the module.
     */
    static resolveArticlesCount(module, list) {
        if (!module.content.list || module.content.list.value.toString() !== list.value.toString()) {
            return 0;
        }
        return ArticlesList_helpers_1.getArticlesCount(module.size, module.version);
    }
};
ArticlesListModuleUi = __decorate([
    vue_property_decorator_1.Component({
        name: 'ArticlesListModuleUi',
        components: { LineHeader: ui_2.LineHeader, BootstrapLink: front_1.BootstrapLink },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <section class="articles-list module" :class="[debugClass, loadingClass, moduleColoredClass,getThemeByBgClass]"
             :style="{ backgroundColor: customColor }">

    <!-- Header -->
    <LineHeader v-if="shouldShowHeader" :site="header.site" class="articles-list__header"
                :isBold="header.isLink || header.bold || false">
      <!-- Text -->
      <template v-if="theme !== AppTheme.PremiumZone && hasHeaderText && !headerLink">
        {{ module.content.header.text }}
      </template>

      <template v-if="theme !== AppTheme.PremiumZone && hasHeaderText && headerLink">
        <BootstrapLink :link="{target: { path: headerLink }}" style="text-decoration: none">
          {{ module.content.header.text }}
        </BootstrapLink>
      </template>
    </LineHeader>

    <!-- Articles list -->
    <component :is="component"
               v-bind="{
                   articles,
                   fallbackImage,
                   readMoreLink,
                   listConfig,
                   relatedService,
                   windowService,
                   isLazy: module.isLazyLoaded
                 }"/>

    </section>
  `
    })
], ArticlesListModuleUi);
exports.ArticlesListModuleUi = ArticlesListModuleUi;
//# sourceMappingURL=ArticlesList.ui.js.map